import React, { useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { MESI } from '../../utils/agenda';
import { euro, passiOfferte } from '../../utils/scheda';
import Icona from '../cliente/Icone';
import Provvigione from '../staff/Provvigione';
import { useInvioUnico } from '../accesso/campi';
import { errore } from './comuni';

// Un invio alla volta (doppio clic su "Salva", "Sì, elimina", "Genera PDF"): prima due POST /risposta scrivevano due
// "controproposta 372.000 €" (due Novità, due campanelle, due push al cliente). → [inVolo, esegui(fn)]
const useUnaVolta = () => {
  const invio = useInvioUnico();
  const [inVolo, setInVolo] = useState(false);
  const esegui = async (fn) => {
    if (!invio.blocca()) return;
    setInVolo(true);
    try { await fn(); } finally { invio.sblocca(); setInVolo(false); }
  };
  return [inVolo, esegui];
};

// Scheda "Proposte" della scheda cliente: per ogni proposta richiesto, offerto, caparra, subordinata al mutuo, scadenza,
// rogito entro; la fila delle offerte (la vede anche il cliente nella scheda della casa); "Registra risposta del
// venditore", "Controproposta" (la nostra nuova offerta), "Genera PDF" (dai dati, in archivio tra i documenti "solo per
// noi"), "Modifica" (caparra, date, mutuo) ed "Elimina"; il mutuo quando la proposta è accettata. Solo l'admin agisce.
// Quando la proposta è accettata si compila anche la provvigione della pratica (components/staff/Provvigione.jsx):
// sono soldi, e resta dentro le pagine dello staff.

const STATI = {
  inviata: ['t-o', 'in attesa del venditore'], in_negoziazione: ['t-w', 'in trattativa'], accettata: ['t-g', 'accettata'],
  rifiutata: ['t-r', 'rifiutata'], ritirata: ['t-r', 'ritirata'], da_definire: ['t-b', 'da presentare'],
};
const APERTE = ['inviata', 'in_negoziazione'];

export const dataBreve = (v) => {
  if (!v) return null;
  const x = new Date(v);
  if (Number.isNaN(x.getTime())) return null;
  return `${x.getDate()} ${MESI[x.getMonth()]}${x.getFullYear() !== new Date().getFullYear() ? ` ${x.getFullYear()}` : ''}`;
};
const perInput = (v) => (v ? String(v).slice(0, 10) : '');

// "10.000 € · da consegnare" / "10.000 € · versata il 12 settembre"
export const testoCaparra = (p) => {
  if (!euro(p.rogito_importo_caparra)) return null;
  return `${euro(p.rogito_importo_caparra)} · ${p.rogito_data_caparra ? `versata il ${dataBreve(p.rogito_data_caparra)}` : 'da consegnare'}`;
};
// "Sì · Intesa 180.000 € · delibera attesa il 25 settembre"
export const testoSubordinata = (p) => {
  if (!p.subordinato) return 'No';
  const banca = [p.mutuo_banca, euro(p.mutuo_importo)].filter(Boolean).join(' ');
  const quando = p.mutuo_data_delibera ? `delibera attesa il ${dataBreve(p.mutuo_data_delibera)}` : p.subordinato_fino_a ? `fino al ${dataBreve(p.subordinato_fino_a)}` : null;
  return ['Sì', banca, quando].filter(Boolean).join(' · ');
};

const ModificaProposta = ({ p, chiudi, onFatto }) => {
  const [dati, setDati] = useState({
    rogito_importo_caparra: p.rogito_importo_caparra || '', rogito_data_caparra: perInput(p.rogito_data_caparra),
    data_scadenza: perInput(p.data_scadenza), rogito_entro: perInput(p.rogito_entro), subordinato: Boolean(p.subordinato),
    subordinato_fino_a: perInput(p.subordinato_fino_a), mutuo_banca: p.mutuo_banca || '', mutuo_importo: p.mutuo_importo || '', note: p.note || '',
  });
  const [attesa, setAttesa] = useState(false);
  const campo = (k, props = {}) => <input value={dati[k]} onChange={(e) => setDati({ ...dati, [k]: e.target.value })} {...props} />;
  const salva = async (e) => {
    e.preventDefault();
    setAttesa(true);
    try {
      const corpo = { ...dati };
      ['rogito_data_caparra', 'data_scadenza', 'rogito_entro', 'subordinato_fino_a'].forEach((k) => { if (!corpo[k]) corpo[k] = null; });
      await axios.put(`${API}/proposte/${p.id}`, corpo);
      toast.success('Proposta aggiornata: la scadenza in agenda segue la data nuova');
      onFatto();
    } catch (err) { errore(err); setAttesa(false); }
  };
  return (
    <form className="riquadro" onSubmit={salva} style={{ marginTop: '1rem' }} data-testid={`modifica-proposta-${p.id}`}>
      <div className="form-griglia" style={{ marginTop: 0 }}>
        <label>Caparra (€){campo('rogito_importo_caparra', { inputMode: 'numeric', placeholder: 'es. 10000' })}</label>
        <label>Caparra versata il{campo('rogito_data_caparra', { type: 'date' })}</label>
        <label>Scadenza della proposta{campo('data_scadenza', { type: 'date' })}</label>
        <label>Rogito entro{campo('rogito_entro', { type: 'date' })}</label>
        <label>Subordinata al mutuo
          <select value={dati.subordinato ? 'si' : 'no'} onChange={(e) => setDati({ ...dati, subordinato: e.target.value === 'si' })}><option value="no">No</option><option value="si">Sì</option></select>
        </label>
        {dati.subordinato && <label>Condizione fino al{campo('subordinato_fino_a', { type: 'date' })}</label>}
        {dati.subordinato && <label>Banca{campo('mutuo_banca', { placeholder: 'es. Intesa' })}</label>}
        {dati.subordinato && <label>Importo del mutuo (€){campo('mutuo_importo', { inputMode: 'numeric', placeholder: 'es. 180000' })}</label>}
      </div>
      <div className="form-riga">
        {campo('note', { placeholder: 'Note (facoltative)', 'aria-label': 'Note della proposta', style: { flex: 1, minWidth: '14rem' } })}
        <button type="submit" className="btn sm p" disabled={attesa}>{attesa ? 'Salvo…' : 'Salva'}</button>
        <button type="button" className="btn sm" onClick={chiudi}>Annulla</button>
      </div>
    </form>
  );
};

const Proposta = ({ p, onFatto, isAdmin }) => {
  const [modo, setModo] = useState(null);  // 'risposta' | 'rilancio' | 'modifica' | 'elimina'
  const [prezzo, setPrezzo] = useState('');
  const [esito, setEsito] = useState('controproposta');
  const giorniAllaScadenza = p.data_scadenza ? Math.round((new Date(p.data_scadenza) - new Date()) / 86400000) : null;
  const stato = STATI[p.stato] || ['t-o', p.stato];
  const aperta = APERTE.includes(p.stato);
  const cambia = (m) => setModo(modo === m ? null : m);
  const [inVolo, esegui] = useUnaVolta();
  const invia = () => esegui(async () => {
    try {
      if (modo === 'risposta') await axios.post(`${API}/proposte/${p.id}/risposta`, { esito, prezzo: esito === 'controproposta' ? prezzo : undefined });
      else await axios.post(`${API}/proposte/${p.id}/rilancio`, { prezzo });
      toast.success('Proposta aggiornata');
      setModo(null); setPrezzo('');
      onFatto();
    } catch (e) { errore(e); }
  });
  const pdf = () => esegui(async () => {
    try {
      const r = await axios.post(`${API}/proposte/${p.id}/pdf`);
      toast.success(`PDF in archivio (solo per noi): ${r.data.nome_file}`);
      onFatto();
    } catch (e) { errore(e); }
  });
  const elimina = () => esegui(async () => {
    try {
      await axios.delete(`${API}/proposte/${p.id}`);
      toast.success('Proposta eliminata');
      onFatto();
    } catch (e) { errore(e); }
  });
  return (
    <section className="card hero r" data-testid={`proposta-${p.id}`}>
      <div className="ttl"><div className="i"><Icona nome="euro" /></div><h2>Proposta · {p.immobile_titolo || 'immobile'}</h2><span className={`tag ${stato[0]}`}>{stato[1]}</span></div>
      <div className="kv">
        <div><small>Richiesto</small><b>{euro(p.prezzo_richiesto || p.immobile_prezzo) || '—'}</b></div>
        <div><small>Offerto</small><b>{euro(p.prezzo_offerto) || '—'}{p.data_proposta ? ` · ${dataBreve(p.data_proposta)}` : ''}</b></div>
        {p.controproposta && <div><small>Controproposta del venditore</small><b className="w">{euro(p.controproposta)}</b></div>}
        <div><small>Caparra</small><b className={testoCaparra(p) ? undefined : 'vuoto'}>{testoCaparra(p) || '—'}</b></div>
        <div><small>Subordinata al mutuo</small><b>{testoSubordinata(p)}</b></div>
        <div><small>Scadenza proposta</small><b className={giorniAllaScadenza !== null && giorniAllaScadenza <= 3 && aperta ? 'w' : undefined}>{dataBreve(p.data_scadenza) || '—'}</b></div>
        <div><small>Rogito entro</small><b>{dataBreve(p.rogito_entro) || dataBreve(p.rogito_data_prevista) || '—'}</b></div>
      </div>
      {(p.storico_offerte || []).length > 0 && (
        <div className="timeline" aria-label="Storico delle offerte">
          {passiOfferte(p.storico_offerte).map((o, n) => <span key={n} className={o.classe}>{o.testo}{o.prezzo && <> <b>{o.prezzo}</b></>}</span>)}
        </div>
      )}
      {isAdmin && p.stato === 'accettata' && <MutuoProposta p={p} onFatto={onFatto} />}
      {/* Provvigione: solo quando la proposta è accettata (prima non c'è niente da compilare). Chi vede cosa lo
          decide il server: al collaboratore arriva la sua quota e basta. Il cliente qui non entra mai. */}
      {p.stato === 'accettata' && <Provvigione propostaId={p.id} />}
      {isAdmin && (
        <div style={{ marginTop: '1rem', display: 'flex', gap: '.5rem', flexWrap: 'wrap' }}>
          {aperta && <button type="button" className="btn sm p" onClick={() => cambia('risposta')}>Registra risposta del venditore</button>}
          {aperta && <button type="button" className="btn sm" onClick={() => cambia('rilancio')}>Controproposta</button>}
          <button type="button" className="btn sm" onClick={pdf} disabled={inVolo}>Genera PDF</button>
          <button type="button" className="btn sm" onClick={() => cambia('modifica')}>Modifica</button>
          <button type="button" className="btn sm rosso-vuoto" onClick={() => cambia('elimina')}>Elimina</button>
        </div>
      )}
      {(modo === 'risposta' || modo === 'rilancio') && (
        <div className="form-riga">
          {modo === 'risposta' && (
            <select value={esito} onChange={(e) => setEsito(e.target.value)} aria-label="Risposta del venditore">
              <option value="controproposta">Controproposta</option><option value="accettata">Accettata</option><option value="rifiutata">Rifiutata</option>
            </select>
          )}
          {(modo === 'rilancio' || esito === 'controproposta') && <input value={prezzo} onChange={(e) => setPrezzo(e.target.value)} inputMode="numeric" placeholder="Prezzo" aria-label="Prezzo" />}
          <button type="button" className="btn sm p" onClick={invia} disabled={inVolo}>{inVolo ? 'Salvo…' : 'Salva'}</button>
        </div>
      )}
      {modo === 'modifica' && <ModificaProposta p={p} chiudi={() => setModo(null)} onFatto={() => { setModo(null); onFatto(); }} />}
      {modo === 'elimina' && (
        <div className="form-riga" role="alert">
          <span>Eliminare la proposta? Sparisce anche la sua scadenza dall'agenda; il PDF già generato resta in archivio.</span>
          <button type="button" className="btn sm rosso" onClick={elimina} disabled={inVolo}>Sì, elimina</button>
          <button type="button" className="btn sm" onClick={() => setModo(null)}>No</button>
        </div>
      )}
    </section>
  );
};

// Mutuo della proposta accettata: il passo della banca e le date (il cliente li vede nella card "Il vostro percorso")
const PASSI_BANCA = [['richiesto', 'Istruttoria', 'mutuo_data_richiesta'], ['perizia', 'Perizia', 'mutuo_data_perizia'],
  ['delibera', 'Delibera', 'mutuo_data_delibera'], ['erogato', 'Erogazione', 'mutuo_data_erogazione']];
const MutuoProposta = ({ p, onFatto }) => {
  const [dati, setDati] = useState(() => ({ mutuo_banca: p.mutuo_banca || '', mutuo_stato: p.mutuo_stato || '',
    ...Object.fromEntries(PASSI_BANCA.map(([, , campo]) => [campo, p[campo] ? String(p[campo]).slice(0, 10) : ''])) }));
  const [inVolo, esegui] = useUnaVolta();
  const salva = () => esegui(async () => {
    try {
      await axios.put(`${API}/proposte/${p.id}`, { ...dati, mutuo_richiesto: true,
        ...Object.fromEntries(PASSI_BANCA.map(([, , campo]) => [campo, dati[campo] || null])) });
      toast.success('Mutuo aggiornato: il cliente vede il passo nella sua home');
      onFatto();
    } catch (e) { errore(e); }
  });
  return (
    <div className="mutuo-staff" data-testid={`mutuo-${p.id}`}>
      <small>Mutuo</small>
      <div className="form-riga" style={{ marginTop: '.4rem' }}>
        <input value={dati.mutuo_banca} onChange={(e) => setDati({ ...dati, mutuo_banca: e.target.value })} placeholder="Banca" aria-label="Banca" />
        <select value={dati.mutuo_stato} onChange={(e) => setDati({ ...dati, mutuo_stato: e.target.value })} aria-label="Passo della banca">
          <option value="">Da richiedere</option>
          {PASSI_BANCA.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
          <option value="rifiutato">Rifiutato</option>
        </select>
        {PASSI_BANCA.map(([, n, campo]) => (
          <label key={campo} className="data-mutuo">{n}<input type="date" value={dati[campo]} onChange={(e) => setDati({ ...dati, [campo]: e.target.value })} aria-label={`Data ${n.toLowerCase()}`} /></label>
        ))}
        <button type="button" className="btn sm p" onClick={salva} disabled={inVolo}>{inVolo ? 'Salvo…' : 'Salva'}</button>
      </div>
    </div>
  );
};

const TabProposte = ({ proposte, onFatto, isAdmin, apri }) => (
  <div className="stack">
    {isAdmin && <div><button type="button" className="btn sm p" onClick={() => apri('proposta')}>+ Nuova proposta</button></div>}
    {!proposte.length && <section className="card"><p className="vuoto">Nessuna proposta.</p></section>}
    {proposte.map((p) => <Proposta key={p.id} p={p} onFatto={onFatto} isAdmin={isAdmin} />)}
  </div>
);

export default TabProposte;
